<template>
  <b-overlay :show="loading">
    <!-- Paso 1: Formulario de datos -->
    <form v-if="!showQuestions" data-vv-scope="user">
      <div class="row mt-3">
        <div class="col-6 mt-2">
          <vs-input
            autocomplete="off"
            class="w-100 cursor-default"
            label="Rut"
            maxlength="12"
            name="iut"
            v-model="cuUserData.iut"
            readonly
          />
        </div>
        <div class="col-6 mt-2">
          <vs-input
            autocomplete="off"
            class="w-100"
            label="Nombres"
            maxlength="250"
            name="name"
            v-model="cuUserData.name"
            :danger="errors.has('user.name')"
            :danger-text="errors.first('user.name')"
            v-validate="'required'"
          />
        </div>
        <div class="col-6 mt-2">
          <vs-input
            autocomplete="off"
            class="w-100"
            label="Apellido Paterno"
            maxlength="200"
            name="lastName"
            v-model="cuUserData.lastName"
            :danger="errors.has('user.lastName')"
            :danger-text="errors.first('user.lastName')"
            v-validate="'required'"
          />
        </div>
        <div class="col-6 mt-2">
          <vs-input
            autocomplete="off"
            class="w-100"
            label="Apellido Materno"
            maxlength="250"
            name="mothersLastName"
            v-model="cuUserData.mothersLastName"
          />
        </div>
        <div class="col-6 mt-2">
          <vs-input
            autocomplete="off"
            class="w-100"
            label="Número Documento / Número de serie"
            maxlength="200"
            name="iutNumber"
            v-model="cuUserData.iutNumber"
            :danger="errors.has('user.iutNumber')"
            :danger-text="errors.first('user.iutNumber')"
            v-validate="'required'"
          />
        </div>
        <div class="col-6 mt-2">
          <vs-input
            autocomplete="off"
            class="w-100"
            label="Correo Personal"
            maxlength="250"
            name="email"
            v-model="cuUserData.email"
            :danger="errors.has('user.email')"
            :danger-text="errors.first('user.email')"
            v-validate="'required|email'"
          />
        </div>
        <div class="col-6 mt-2">
          <vs-input
            autocomplete="off"
            class="w-100"
            label="Comuna"
            maxlength="100"
            name="commune"
            v-model="cuUserData.commune"
            :danger="errors.has('user.commune')"
            :danger-text="errors.first('user.commune')"
            v-validate="'required'"
          />
        </div>
        <div class="col-6 mt-2">
          <vs-input
            autocomplete="off"
            class="w-100"
            label="Teléfono móvil"
            maxlength="25"
            name="phone"
            v-model="cuUserData.phone"
            :danger="errors.has('user.phone')"
            :danger-text="errors.first('user.phone')"
            v-validate="'required|numeric'"
          />
        </div>
      </div>
      <div class="text-right mt-4">
        <b-button
          variant="primary"
          @click="submitForm"
          :disabled="loading"
        >
          Continuar verificación
        </b-button>
      </div>
    </form>

    <!-- Paso 2: Preguntas de seguridad -->
    <div v-if="showQuestions">
      <h5 class="mb-4">Preguntas de verificación de identidad</h5>
      <p class="text-muted mb-4">Responda las siguientes preguntas para confirmar su identidad.</p>
      <div v-for="(pregunta, key) in securityQuestions" :key="key" class="mb-4">
        <label class="font-weight-bold">{{ pregunta.text || key }}</label>
        <b-form-radio-group
          v-model="answers[key]"
          :options="formatOptions(pregunta.opciones || pregunta.options)"
          stacked
          class="mt-2"
        />
      </div>
      <div class="text-right mt-4">
        <b-button
          variant="primary"
          @click="submitAnswers"
          :disabled="loading || !allQuestionsAnswered"
        >
          Verificar y generar certificado
        </b-button>
      </div>
    </div>
  </b-overlay>
</template>
<script>
import { cuVerificationInfoExternal, cuEsignCertifiedExternal } from "@/febos/servicios/api/v2.aprobaciones.api";

export default {
  name: 'VerificationFormExternalSignApi',
  props: {
    cuUserData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      showQuestions: false,
      securityQuestions: {},
      sToken: null,
      answers: {},
    };
  },
  computed: {
    token() {
      const { token } = this.$route.params;
      return token;
    },
    allQuestionsAnswered() {
      const keys = Object.keys(this.securityQuestions);
      if (keys.length === 0) return false;
      return keys.every(key => this.answers[key] !== undefined && this.answers[key] !== null);
    }
  },
  methods: {
    formatOptions(opciones) {
      if (!opciones) return [];
      if (Array.isArray(opciones)) {
        return opciones.map(opt => ({
          text: opt.texto || opt.text || opt.label,
          value: opt.id || opt.value
        }));
      }
      // Object format (opcion1, opcion2, etc.)
      return Object.values(opciones).map(opt => ({
        text: opt.texto || opt.text,
        value: opt.id
      }));
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async submitForm() {
      const isValid = await this.validateForm('user');
      if (!isValid) return;

      const { idProceso } = this.$route.query;
      this.loading = true;

      try {
        // Paso 1: Validar datos personales
        await cuVerificationInfoExternal({
          params: {
            tipo: 'signapi',
            accion: 'validar_datos',
          },
          headers: {
            Authorization: this.token,
          },
          body: {
            idProceso,
            rut: this.cuUserData.iut,
            nombres: this.cuUserData.name,
            apellidoPaterno: this.cuUserData.lastName,
            apellidoMaterno: this.cuUserData.mothersLastName || '',
            correoPersonal: this.cuUserData.email,
            telefonoMovil: this.cuUserData.phone,
            numeroSerie: this.cuUserData.iutNumber,
            comuna: this.cuUserData.commune,
          }
        });

        // Paso 2: Solicitar certificado (primera llamada PUT) → retorna preguntas
        const certResponse = await cuEsignCertifiedExternal({
          params: {
            tipo: 'signapi',
            accion: 'verificar',
          },
          headers: {
            Authorization: this.token,
          },
          body: {
            idProceso,
            rut: this.cuUserData.iut,
            nombres: this.cuUserData.name,
            apellidoPaterno: this.cuUserData.lastName,
            apellidoMaterno: this.cuUserData.mothersLastName || '',
            correoPersonal: this.cuUserData.email,
            telefonoMovil: this.cuUserData.phone,
            numeroSerie: this.cuUserData.iutNumber,
            comuna: this.cuUserData.commune,
          }
        });

        this.loading = false;

        // Verificar si retornó preguntas
        if (certResponse.data && certResponse.data.preguntas) {
          this.securityQuestions = certResponse.data.preguntas;
          this.sToken = certResponse.data.sToken;
          this.showQuestions = true;
        } else {
          // Si no hay preguntas, el certificado se generó directamente (caso simulado)
          this.$emit('completed');
        }
      } catch (error) {
        this.loading = false;
        this.$bvToast.toast(
          error.response?.data?.errores?.[0] || 'Error al procesar la solicitud',
          {
            title: 'Error',
            variant: 'danger',
            solid: true,
            noAutoHide: true
          }
        );
      }
    },
    async submitAnswers() {
      const { idProceso } = this.$route.query;
      this.loading = true;

      try {
        // Formatear respuestas como array de objetos {id, answer}
        const respuestasFormateadas = Object.entries(this.answers).map(([key, value]) => ({
          id: this.securityQuestions[key]?.id || key,
          answer: value
        }));

        // Segunda llamada PUT con respuestas
        await cuEsignCertifiedExternal({
          params: {
            tipo: 'signapi',
            accion: 'verificar',
          },
          headers: {
            Authorization: this.token,
          },
          body: {
            idProceso,
            respuestas: respuestasFormateadas,
          }
        });

        this.loading = false;
        this.$bvToast.toast(
          'Certificado generado exitosamente',
          {
            title: 'Firma electrónica',
            variant: 'success',
            solid: true,
            autoHideDelay: 3000
          }
        );
        this.$emit('completed');
      } catch (error) {
        this.loading = false;
        this.$bvToast.toast(
          error.response?.data?.errores?.[0] || 'Error en la verificación de identidad',
          {
            title: 'Error',
            variant: 'danger',
            solid: true,
            noAutoHide: true
          }
        );
      }
    }
  }
}
</script>
